import { render, staticRenderFns } from "./TheGeneralSignatureInbox.vue?vue&type=template&id=07bc1ad5&scoped=true&"
import script from "./TheGeneralSignatureInbox.vue?vue&type=script&lang=js&"
export * from "./TheGeneralSignatureInbox.vue?vue&type=script&lang=js&"
import style0 from "./TheGeneralSignatureInbox.vue?vue&type=style&index=0&id=07bc1ad5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc1ad5",
  null
  
)

export default component.exports